<template>
  <span v-resize="checkMobile" :style="isMobile ? 'padding: 5px !important;' : ''">
    <!-- <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading> -->
    <v-card>
      <v-card-title>
        <h3 class="text-h5" @click="resetActiveDialog" style="cursor: pointer">{{ $t('teletype.teletype') }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="loadDialogs">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text ref="chatContainer" style="scroll-margin-bottom: 150px;">
        <v-divider></v-divider>
        <v-row class="no-gutters elevation-4">
          <v-col cols="12" sm="3" class="flex-grow-1 flex-shrink-0" style="border-right: 1px solid #0000001f;">
            <v-responsive class="overflow-y-auto fill-height" height="800">
              <v-list subheader>
                <v-list-item-group class="d-flex align-center justify-center">
                  <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" class="mx-3 my-3" single-line clearable hide-details></v-text-field>
                </v-list-item-group>

                <!-- Скелетон для списка диалогов -->
                <template v-if="isLoading && !messages.length">
                  <v-skeleton-loader
                    v-for="i in 8"
                    :key="'dialog-skeleton-'+i"
                    type="list-item-avatar-two-line"
                    class="mb-1 mx-2"
                  ></v-skeleton-loader>
                </template>

                <!-- Реальный список диалогов -->
                <v-list-item-group v-else v-model="activeDialog">
                  <template v-for="(dialog, index) in filteredDialogs">
                    <v-list-item :key="`dialog${index}`" :value="dialog.id" @click="loadMessagesForDialog(dialog)">
                      <v-list-item-avatar color="grey lighten-1 white--text">
                        <v-avatar v-if="dialog.client && dialog.client.avatar" size="40" class="m-2">
                          <v-img :src="dialog.client.avatar" />
                        </v-avatar>
                        <v-avatar v-else :color="dialog.hasActiveBooking ? 'success' : 'grey lighten-1'" size="40" class="m-2">
                          <v-flex class="text-uppercase">
                            {{ getInitials(dialog) }}
                          </v-flex>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-badge v-if="dialog.statusName != 'open'" color="deep-purple accent-4" dot>
                            <span v-text="dialog.client ? dialog.client.name : dialog.title"></span>
                          </v-badge>
                          <v-badge v-else-if="dialog.hasUnreadMessages && (!currentDialog || currentDialog.id !== dialog.id)" color="green" :content="dialog.unreadCount">
                            <span v-text="dialog.client && dialog.client.name ? dialog.client.name : (dialog.title ? dialog.title : dialog.channel.name)"></span>
                          </v-badge>
                          <span v-else-if="dialog.client && dialog.client.name" v-text="dialog.client.name"></span>
                          <span v-else-if="dialog.title" v-text="dialog.title"></span>
                          <span v-else v-text="dialog.channel.name"></span>
                        </v-list-item-title>
                        <v-list-item-subtitle v-text="dialog.client ? dialog.client.phone : ''" />
                        <v-list-item-subtitle>
                          {{ getLastMessagePreview(dialog) }}
                          <v-icon x-small color="amber" v-if="dialog.hasUnreadMessages && (!currentDialog || currentDialog.id !== dialog.id)" class="ml-1">mdi-eye-off-outline</v-icon>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="dialog.lastMessageAt" class="text-caption">
                          <timeago :datetime="formatDialogTime(dialog.lastMessageAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`dialogDivider${index}`" class="my-0" />
                  </template>
                </v-list-item-group>
              </v-list>
            </v-responsive>
          </v-col>

          <!-- Скелетон загрузки для сообщений чата -->
          <v-col v-if="isLoading && currentDialog">
            <v-card flat>
              <v-skeleton-loader
                v-for="i in 8"
                :key="'message-skeleton-'+i"
                type="list-item-avatar-two-line"
                class="mb-1 mx-2"
              ></v-skeleton-loader>
            </v-card>
          </v-col>

          <!-- Пустой экран чата с приглашением -->
          <v-col v-else-if="!messages || messages.length === 0" class="d-flex align-center justify-center">
            <v-card flat>
              <v-card-text class="text-center">
                <v-icon size="64" color="grey lighten-1">mdi-chat-outline</v-icon>
                <h3 class="mt-3">{{ $t('teletype.select_dialog') }}</h3>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Реальные сообщения чата -->
          <v-col v-else>
            <v-card v-for="(message, index) in messages" :key="index" flat>
              <v-list-item :key="message.id" v-if="!message.isItClient && !message.isOutgoing" class="">
                <v-list-item-avatar class="align-self-start mr-2">
                  <v-avatar size="40" color="primary">
                    {{ $t('custom.you') }}
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content class="sent-message">
                  <v-card v-if="!message.attachments || message.attachments.length === 0" color="primary" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption"></span>
                      <span class="align-self-start text-subtitle-1" v-html="parseEmoji(message.text)"></span>
                      <span class="text-caption font-italic align-self-end d-flex align-center">
                        <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                        <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                        <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                        <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                        <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <template v-else v-for="(attachment, idx) in message.attachments">
                    <v-card v-if="attachment.type === 'image'" :key="'img-'+idx" color="primary" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <v-img :lazy-src="attachment.thumbnailUrl || attachment.url" max-height="150" max-width="250"
                          :src="attachment.url" @click="downloadFile(attachment.url, attachment.name)"></v-img>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="attachment.type === 'audio'" :key="'audio-'+idx" color="primary" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <span class="align-self-start text-subtitle-1">
                          <audio controls>
                            <source :src="attachment.url" type="audio/ogg">
                            <source :src="attachment.url" type="audio/mpeg">
                          </audio>
                        </span>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="attachment.type === 'document'" :key="'doc-'+idx" color="primary" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <v-btn color="secondary" text @click="downloadFile(attachment.url, attachment.name)">
                          {{ attachment.name || 'Документ' }}
                        </v-btn>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="attachment.type === 'video'" :key="'video-'+idx" color="primary" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column" style="cursor: pointer;">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <v-img :lazy-src="attachment.thumbnailUrl || attachment.url" max-height="150" max-width="250"
                          :src="attachment.url" @click="downloadFile(attachment.url, attachment.name)">
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-icon color="grey lighten-1" dark size="64"
                                @click="downloadFile(attachment.url, attachment.name)">
                                mdi-youtube
                              </v-icon>
                            </v-row>
                          </template>
                        </v-img>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else :key="message.id">
                <v-list-item-content class="received-message">
                  <v-card v-if="!message.attachments || message.attachments.length === 0" color="success" class="flex-none">
                    <v-card-text class="white--text pa-2 d-flex flex-column">
                      <span class="text-caption"></span>
                      <span class="align-self-start text-subtitle-1" v-html="parseEmoji(message.text)"></span>
                      <span class="text-caption font-italic align-self-end d-flex align-center">
                        <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                        <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                        <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                        <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                        <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                      </span>
                    </v-card-text>
                  </v-card>
                  <template v-else v-for="(attachment, idx) in message.attachments">
                    <v-card v-if="attachment.type === 'image'" :key="'img-'+idx" color="success" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <v-img :lazy-src="attachment.thumbnailUrl || attachment.url" max-height="150" max-width="250"
                          :src="attachment.url" @click="downloadFile(attachment.url, attachment.name)"></v-img>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="attachment.type === 'audio'" :key="'audio-'+idx" color="success" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <span class="align-self-start text-subtitle-1">
                          <audio controls>
                            <source :src="attachment.url" type="audio/ogg">
                            <source :src="attachment.url" type="audio/mpeg">
                          </audio>
                        </span>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="attachment.type === 'document'" :key="'doc-'+idx" color="success" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <v-btn color="primary" text @click="downloadFile(attachment.url, attachment.name)">
                          {{ attachment.name || 'Документ' }}
                        </v-btn>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="attachment.type === 'video'" :key="'video-'+idx" color="success" class="flex-none">
                      <v-card-text class="white--text pa-2 d-flex flex-column" style="cursor: pointer;">
                        <span class="text-caption">{{ message.text || '' }}</span>
                        <v-img :lazy-src="attachment.thumbnailUrl || attachment.url" max-height="150" max-width="250"
                          :src="attachment.url" @click="downloadFile(attachment.url, attachment.name)">
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-icon color="grey lighten-1" dark size="64"
                                @click="downloadFile(attachment.url, attachment.name)">
                                mdi-youtube
                              </v-icon>
                            </v-row>
                          </template>
                        </v-img>
                        <span class="text-caption font-italic align-self-end d-flex align-center">
                          <v-icon x-small class="mr-1" v-if="message.status === 10">mdi-clock-outline</v-icon>
                          <v-icon x-small class="mr-1" color="error" v-else-if="message.status === 20">mdi-alert</v-icon>
                          <v-icon x-small class="mr-1" color="success" v-else-if="message.status === 30">mdi-check-all</v-icon>
                          <v-icon x-small class="mr-1" color="amber" v-if="message.seen === false">mdi-eye-off-outline</v-icon>
                          <timeago :datetime="formatMessageTime(message.createdAt)" :auto-update="60" :locale="$i18n.locale"></timeago>
                        </span>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-list-item-content>
                <v-list-item-avatar class="align-self-start ml-2">
                  <v-avatar v-if="currentDialog && currentDialog.client && currentDialog.client.avatar" size="40">
                    <v-img :src="currentDialog.client.avatar" v-if="currentDialog.client.avatar" />
                    <v-icon v-else>mdi-account-circle</v-icon>
                  </v-avatar>
                  <v-avatar v-else size="40" color="success">
                    {{ getInitials(currentDialog) }}
                  </v-avatar>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
            <v-container class="ma-0 px-3" v-if="messages && messages.length > 0">
              <v-row no-gutters>
                <v-col>
                  <v-flex class="d-flex align-center">
                    <v-file-input class="flex-none" hide-input hide-details flat truncate-length="15"
                      v-model="attachment" dense inline solo></v-file-input>
                    <v-textarea rows="1" autofocus auto-grow v-model="newMessage" class="w-full"
                      :placeholder="$t('companies.type_something')" @keypress.enter="sendMessage()"></v-textarea>
                    <v-btn icon class="ml-4" @click="sendMessage()"><v-icon>mdi-send</v-icon></v-btn>
                  </v-flex>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" class="d-flex justify-center my-2">
            <v-pagination v-model="page" :length="totalPages" @input="loadDialogs, resetActiveDialog()"></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { saveAs } from "file-saver";
import PullToRefresh from "pulltorefreshjs";

export default {
  data() {
    return {
      newMessage: "",
      attachment: null,
      search: "",
      page: 1,
      totalPages: 1,
      activeDialog: null,
      isMobile: false,
    };
  },
  computed: {
    company() {
      if (this.$store.getters.getCompany) {
        return this.$store.getters.getCompany.company;
      } else {
        return null;
      }
    },
    user_role() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.role;
      } else {
        return "";
      }
    },
    isLoading() {
      return this.$store.getters.getTeletypeLoading;
    },
    dialogs() {
      return this.$store.getters.getTeletypeDialogs;
    },
    messages() {
      if (!this.currentDialog) return [];
      let messages = this.$store.getters.getTeletypeDialogMessages(this.currentDialog.id) || [];
      return messages;
    },
    currentDialog() {
      return this.$store.getters.getTeletypeActiveDialog;
    },
    filteredDialogs() {
      if (!this.search) return this.dialogs;

      const searchTerm = this.search.toLowerCase();
      return this.dialogs.filter(dialog => {
        const clientName = dialog.client ? (dialog.client.name || '').toLowerCase() : '';
        const clientPhone = dialog.client ? (dialog.client.phone || '').toLowerCase() : '';
        const dialogTitle = (dialog.title || '').toLowerCase();

        return clientName.includes(searchTerm) ||
               clientPhone.includes(searchTerm) ||
               dialogTitle.includes(searchTerm);
      });
    }
  },
  mounted() {
    let self = this;
    // Инициализация Pull-to-refresh
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
      onRefresh() {
        return self.loadDialogs();
      }
    });

    // Сбрасываем счетчик новых сообщений при открытии чата
    this.$store.commit("resetTeletypeMessagesCount");
  },
  created() {
    // Установка локали для moment
    if (this.$i18n.locale == "ru") {
      moment.locale("ru");
    } else {
      moment.locale("en-gb");
    }

    if (this.$store.getters.isLoggedIn) {
      this.loadDialogs();
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  beforeDestroy() {
    // Отписка от диалога если был активен
    if (this.currentDialog && this.currentDialog.id) {
      console.log("beforeDestroy unsubscribe TeletypeDialog for dialog:", this.currentDialog.id);
      this.$cable.unsubscribe({
        channel: "TeletypeDialog",
        room: this.currentDialog.id
      });
      this.resetActiveDialog();
    }
  },
  channels: {
    TeletypeChannel: {
      connected() {
        console.log("Connected to TeletypeChannel chat page");
      },
      received(data) {
        console.log("Received TeletypeChannel data:", data);
        // Проверяем наличие данных
        if (!data || !data.name || !data.payload) return;

        try {
          // Парсим JSON из payload
          const payloadData = JSON.parse(data.payload);

          // Обработка события нового сообщения от клиента
          if (data.name === "new message" && payloadData.message) {
            const message = payloadData.message;
            // Устанавливаем seen: false для новых сообщений от клиента
            if (message.isItClient || message.isOutgoing === false) {
              message.seen = false;
            }
            const dialogId = message.dialogId;

            // Добавляем сообщение в счетчик непрочитанных
            this.$store.commit("addTeletypeNewMessage", payloadData);

            // Проверяем, существует ли диалог в списке
            const existingDialog = this.dialogs.find(d => d.id === dialogId);

            if (existingDialog) {
              // Обновляем существующий диалог
              this.$store.commit('updateTeletypeDialog', {
                dialogId: dialogId,
                lastMessage: message
              });

              // Если сообщение от клиента, отмечаем диалог как непрочитанный и увеличиваем счетчик
              if (message.isItClient || message.isOutgoing === false) {
                this.$store.commit('setTeletypeDialogUnread', {
                  dialogId: dialogId,
                  unreadCount: existingDialog.unreadCount ? existingDialog.unreadCount + 1 : 1
                });
              }

              // Если это текущий диалог, добавляем сообщение в него
              if (this.currentDialog && this.currentDialog.id === dialogId) {
                this.$store.commit('addTeletypeDialogMessage', {
                  dialogId: dialogId,
                  message: message
                });
                this.$nextTick(() => this.scrollToBottom());
              }
            } else {
              // Создаем новый диалог на основе сообщения
              this.$store.commit('addTeletypeDialogFromMessage', {
                message: message
              });
            }
          }

          // Обработка события успешной отправки сообщения на уровне компании
          else if (data.name === "success send" && payloadData.dialogId) {
            const dialogId = payloadData.dialogId;
            const messageId = payloadData.messageId;
            const messageStatus = payloadData.messageStatus;

            // Обновляем статус сообщения, если это текущий диалог
            if (this.currentDialog && this.currentDialog.id === dialogId) {
              this.$store.commit('updateTeletypeMessageStatus', {
                dialogId: dialogId,
                messageId: messageId,
                status: messageStatus
              });
            }

            // Обновляем статус последнего сообщения в диалоге
            this.$store.commit('updateTeletypeDialogMessageStatus', {
              dialogId: dialogId,
              messageId: messageId,
              status: messageStatus
            });
          }

          // Обработка события изменения статуса сообщения на уровне компании
          else if (data.name === "message status change" && payloadData.dialogId) {
            const dialogId = payloadData.dialogId;
            const messageId = payloadData.messageId;
            const messageStatus = payloadData.messageStatus;

            // Обновляем статус сообщения, если это текущий диалог
            if (this.currentDialog && this.currentDialog.id === dialogId) {
              this.$store.commit('updateTeletypeMessageStatus', {
                dialogId: dialogId,
                messageId: messageId,
                status: messageStatus
              });
            }

            // Обновляем статус последнего сообщения в диалоге
            this.$store.commit('updateTeletypeDialogMessageStatus', {
              dialogId: dialogId,
              messageId: messageId,
              status: messageStatus
            });
          }
        } catch (error) {
          console.error("Ошибка при обработке WebSocket сообщения для компании:", error);
        }
      }
    },
    TeletypeDialog: {
      connected() {
        console.log("Connected to TeletypeDialog for dialog:", this.currentDialog?.id);
      },
      received(data) {
        console.log("Received dialog data:", data);
        if (!data || !data.name || !data.payload) return;

        try {
          // Парсим JSON из payload
          const payloadData = JSON.parse(data.payload);

          // Обработка события нового сообщения для диалога
          if (data.name === "new message" && payloadData.message) {
            const message = payloadData.message;
            console.log("New message in TeletypeChat:", message);

            // Добавляем сообщение в стор
            this.$store.commit('addTeletypeDialogMessage', {
              dialogId: this.currentDialog.id,
              message: message
            });

            // Обновляем диалог в списке диалогов
            this.$store.commit('updateTeletypeDialog', {
              dialogId: this.currentDialog.id,
              lastMessage: message
            });

            this.$nextTick(() => this.scrollToBottom());
          }

          // Обработка события изменения статуса сообщения для диалога
          else if (data.name === "message status change" && payloadData.messageId) {
            // Обновляем статус сообщения в стор
            this.$store.commit('updateTeletypeMessageStatus', {
              dialogId: this.currentDialog.id,
              messageId: payloadData.messageId,
              status: payloadData.messageStatus
            });

            // Если это последнее сообщение в диалоге, также обновляем его статус в списке диалогов
            this.$store.commit('updateTeletypeDialogMessageStatus', {
              dialogId: this.currentDialog.id,
              messageId: payloadData.messageId,
              status: payloadData.messageStatus
            });
          }
        } catch (error) {
          console.error("Ошибка при обработке WebSocket сообщения для диалога:", error);
        }
      }
    }
  },
  methods: {
    loadDialogs() {
      if (!this.company || !this.$store.getters.isLoggedIn) return;

      this.$store.commit('setTeletypeLoading', true);

      // Загружаем диалоги через действие Vuex
      this.$store.dispatch('loadTeletypeDialogs', { page: this.page, pageSize: 10 })
        .then(result => {
          if (result && result.totalPages) {
            this.totalPages = result.totalPages;
          }
        })
        .catch(error => {
          this.setError(error, this.$t("errors.dialogs_load"));
        })
        .finally(() => {
          this.$store.commit('setTeletypeLoading', false);
        });
    },

    loadMessagesForDialog(dialog) {
      if (!dialog || !dialog.id) return;

      // Устанавливаем состояние загрузки
      this.$store.commit('setTeletypeLoading', true);

      // Отписываемся от предыдущего диалога если был
      if (this.currentDialog && this.currentDialog.id && this.currentDialog.id !== dialog.id) {
        this.$cable.unsubscribe({
          channel: "TeletypeDialog",
          room: this.currentDialog.id
        });
        console.log("Unsubscribed from previous dialog:", this.currentDialog.id);
      }

      // Устанавливаем активный диалог в store
      this.$store.commit('setTeletypeActiveDialog', dialog);

      // Подписываемся на канал диалога, только если еще не подписаны
      if (!this.hasSubscription("TeletypeDialog", dialog.id)) {
        this.$cable.subscribe({
          channel: "TeletypeDialog",
          room: dialog.id
        });
        console.log("Subscribed to new dialog:", dialog.id);
      }

      // Загружаем сообщения через Vuex действие
      this.$store.dispatch('loadTeletypeDialogMessages', dialog.id)
        .then(() => {
          // Прокручиваем к последнему сообщению
          this.$nextTick(() => this.scrollToBottom());

          // Отмечаем все сообщения как прочитанные
          if (this.messages && this.messages.length > 0) {
            this.messages.forEach(message => {
              if (message.seen === false) {
                this.markMessageAsRead(message);
              }
            });
          }
        })
        .catch(error => {
          this.setError(error, this.$t("errors.messages_load"));
        })
        .finally(() => {
          // Сбрасываем состояние загрузки
          this.$store.commit('setTeletypeLoading', false);
        });
    },

    markDialogAsRead(dialogId) {
      // Отмечаем диалог как прочитанный в сторе
      this.$store.commit('markTeletypeDialogAsRead', dialogId);

      // Здесь можно добавить запрос к API для отметки диалога как прочитанного,
      // если это предусмотрено в Teletype API
    },

    sendMessage() {
      if ((!this.newMessage || this.newMessage.trim() === '') && !this.attachment) {
        this.$swal({
          title: this.$t("errors.error"),
          text: this.$t("errors.message_empty"),
          icon: "error",
          showCancelButton: false,
        });
        return;
      }

      if (!this.currentDialog || !this.currentDialog.id) {
        this.$swal({
          title: this.$t("errors.error"),
          text: this.$t("errors.no_dialog_selected"),
          icon: "error",
          showCancelButton: false,
        });
        return;
      }

      // Отправляем сообщение через действие Vuex
      this.$store.dispatch('sendTeletypeMessage', {
        dialogId: this.currentDialog.id,
        text: this.newMessage,
        file: this.attachment
      })
      .then(() => {
        this.newMessage = "";
        this.attachment = null;
        this.$nextTick(() => this.scrollToBottom());
      })
      .catch(error => {
        this.setError(error, this.$t("errors.message_send"));
      });
    },

    getInitials(dialog) {
      if (!dialog) return '';

      if (dialog && dialog.client) {
        const name = dialog.client.name || '';
        if (name.includes(' ')) {
          const parts = name.split(' ').filter(p => p.length > 0);
          return parts.length > 1 ? `${parts[0][0] || ''}${parts[1][0] || ''}` : name.substring(0, 2);
        }
        return name.substring(0, 2);
      } else if (dialog && dialog.title) {
        return dialog.title.substring(0, 2);
      } else if (dialog.channel && dialog.channel.name) {
        return dialog.channel.name.substring(0, 2);
      }
      return '';
    },

    getLastMessagePreview(dialog) {
      if (dialog && dialog.lastMessage) {
        const message = dialog.lastMessage;
        if (message.text) {
          return message.text.length > 30 ? message.text.substring(0, 30) + '...' : message.text;
        } else if (message.attachments && message.attachments.length > 0) {
          const attachment = message.attachments[0];
          switch (attachment.type) {
            case 'image': return '[Изображение]';
            case 'video': return '[Видео]';
            case 'audio': return '[Аудио]';
            case 'document': return '[Документ]';
            default: return '[Файл]';
          }
        }
      }
      return '';
    },

    formatTime(timestamp) {
      return moment.unix(timestamp).toDate();
    },

    formatMessageTime(timeObj) {
      if (!timeObj) return new Date();
      return timeObj.date ? new Date(timeObj.date) : new Date();
    },

    formatDialogTime(timeObj) {
      if (!timeObj) return new Date();
      return timeObj.date ? new Date(timeObj.date) : new Date();
    },

    parseEmoji(text) {
      if (!text) return '';

      // Преобразуем :emoji: коды в изображения смайлов
      const emojiMap = {
        ':blush:': '😊',
        ':smile:': '😃',
        ':laughing:': '😄',
        ':grin:': '😁',
        ':joy:': '😂',
        ':smiley:': '😀',
        ':rofl:': '🤣',
        ':relaxed:': '☺️',
        ':wink:': '😉',
        ':heart:': '❤️',
        ':heart_eyes:': '😍',
        ':kissing_heart:': '😘',
        ':kissing:': '😗',
        ':kissing_smiling_eyes:': '😙',
        ':kissing_closed_eyes:': '😚',
        ':thumbsup:': '👍',
        ':thumbsdown:': '👎',
        ':ok_hand:': '👌',
        ':punch:': '👊',
        ':facepunch:': '👊',
        ':fist:': '✊',
        ':v:': '✌️',
        ':wave:': '👋',
        ':hand:': '✋',
        ':raised_hand:': '✋',
        ':raised_hands:': '🙌',
        ':pray:': '🙏',
        ':rocket:': '🚀',
        ':tada:': '🎉',
        ':fire:': '🔥',
        ':100:': '💯',
        ':clap:': '👏',
        ':+1:': '👍',
        ':-1:': '👎',
        ':bust_silhouette:': '👤',
        ':mobile_calling:': '📱',
        ':mobile_phone:': '📱',
        ':phone:': '☎️',
        ':oncoming_automobile:': '🚘',
        ':car:': '🚗',
        ':automobile:': '🚗',
        ':round_pushpin:': '📍',
        ':deciduous_tree:': '🌳',
        ':herb:': '🌿',
        ':credit_card:': '💳',
        ':timer:': '⏰',
        ':timer_clock:': '⏰',
        ':clock:': '🕒',
        ':four_leaf_clover:': '🍀'
      };

      let formattedText = text;

      // Заменяем эмодзи-коды на Unicode символы
      Object.keys(emojiMap).forEach(code => {
        const regex = new RegExp(code, 'g');
        formattedText = formattedText.replace(regex, emojiMap[code]);
      });

      // Экранируем HTML
      formattedText = formattedText
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

      // Заменяем переводы строки на <br>
      formattedText = formattedText.replace(/\n/g, '<br>');

      return formattedText;
    },

    scrollToBottom() {
      const container = this.$refs.chatContainer;
      if (container) {
        const scrollHeight = container.scrollHeight;
        container.scrollTo({
          top: scrollHeight,
          behavior: 'smooth'
        });
      }
    },

    downloadFile(url, fileName) {
      if (url) {
        saveAs(url, fileName || 'file');
      }
    },

    goToClientPage() {
      if (this.currentDialog && this.currentDialog.client && this.currentDialog.client.id) {
        this.$router.push({
          path: `/clients/${this.currentDialog.client.id}`
        });
      }
    },

    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },

    setError(error, text) {
      this.$rollbar.configure({
        payload: {
          person: {
            id: this.$store.getters.getCurrentUser
              ? this.$store.getters.getCurrentUser.id
              : null,
            username: this.$store.getters.getCurrentUser.name
              ? this.$store.getters.getCurrentUser.name
              : null,
            email: this.$store.getters.getCurrentUser
              ? this.$store.getters.getCurrentUser.email
              : null,
          },
          custom: {
            company:
              this.$store.getters.getCompany &&
                this.$store.getters.getCompany.company &&
                this.$store.getters.getCompany.company.name
                ? this.$store.getters.getCompany.company.name
                : null,
          },
        },
      });
      this.$rollbar.error(text, error);
      this.$notify(this.$t("errors.error"), `${error}. ${text}`, "error", 5000);
      console.log(error);
    },

    hasSubscription(channelName, roomId) {
      if (!this.$cable || !this.$cable.subscriptions || !this.$cable.subscriptions.subscriptions) {
        return false;
      }

      return this.$cable.subscriptions.subscriptions.some(
        s => s.identifier.includes(`"channel":"${channelName}"`) &&
             s.identifier.includes(`"room":"${roomId}"`)
      );
    },

    resetActiveDialog() {
      // Отписываемся от текущего диалога
      if (this.currentDialog && this.currentDialog.id) {
        this.$cable.unsubscribe({
          channel: "TeletypeDialog",
          room: this.currentDialog.id
        });
        console.log("Unsubscribed from TeletypeDialog for dialog:", this.currentDialog.id);
      }

      // Сбрасываем активный диалог в хранилище
      this.$store.commit('setTeletypeActiveDialog', null);

      // Обновляем список диалогов
      this.loadDialogs();
    },

    markMessageAsRead(message) {
      if (message.seen === false) {
        // Обновляем статус сообщения
        this.$store.commit('updateTeletypeMessage', {
          dialogId: this.currentDialog.id,
          messageId: message.id,
          updates: { seen: true }
        });

        // Отправляем на сервер информацию о прочтении сообщения
        // (если требуется API-вызов)
      }
    }
  }
};
</script>

<style scoped>
.chat-message {
  display: unset !important;
  white-space: break-spaces;
}

.flex-none {
  flex: unset;
}

.received-message::after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: 54px;
  right: auto;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #4caf50 transparent transparent transparent;
}

.sent-message::after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: 54px;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #1976d2 transparent transparent transparent;
}

.w-full {
  width: 100%;
}
</style>
